import {
    Dropdown,
    DropdownButton,
    DropdownDivider,
    DropdownItem,
    DropdownLabel,
    DropdownMenu
} from "../components/catalyst/dropdown";
import {
    ArrowRightStartOnRectangleIcon,
    ChevronDownIcon,
    Cog8ToothIcon,
    LightBulbIcon,
    ShieldCheckIcon,
    UserIcon
} from "@heroicons/react/20/solid";
import {Avatar} from "../components/catalyst/avatar";
import {StackedLayout} from "../components/catalyst/stacked-layout";
import {
    Navbar,
    NavbarDivider,
    NavbarItem,
    NavbarLabel,
    NavbarSection,
    NavbarSpacer
} from "../components/catalyst/navbar";
import {
    Sidebar,
    SidebarBody,
    SidebarHeader,
    SidebarItem,
    SidebarLabel,
    SidebarSection
} from "../components/catalyst/sidebar";
import {useAppSelector} from "../hooks/redux";
import {useHistory} from "react-router-dom";
import GlobalSearch from "../components/GlobalSearch";
import DialogHotelSelector from "../components/navigation/DialogHotelSelector";
import {useTranslation} from "react-i18next";
import {useAuth0} from "@auth0/auth0-react";
import LanguageSelector from "../components/common/LanguageSelector";
import {useSelector} from "react-redux";

function TeamDropdownMenu() {

    const history = useHistory()

    return (
        <DropdownMenu className="min-w-80 lg:min-w-64" anchor="bottom start">
            <DropdownItem onClick={() => history.push('/app/settings')}>
                <Cog8ToothIcon />
                <DropdownLabel>Settings</DropdownLabel>
            </DropdownItem>
            <DropdownDivider />
            <DropdownItem onClick={() => window.open('https://rate.besafesuite.com')}>
                <Avatar slot="icon" src="/logo_rate_small.svg" />
                <DropdownLabel>BeSafe Rate</DropdownLabel>
            </DropdownItem>
            <DropdownItem onClick={() => window.open('https://pay.besafesuite.com')}>
                <Avatar slot="icon" src="/logo_pay_small.svg" />
                <DropdownLabel>BeSafe Pay</DropdownLabel>
            </DropdownItem>
        </DropdownMenu>
    )
}

export default function InternalLayout ({
    children
} : {
    children: any
}) {

    const { t } = useTranslation()
    const history = useHistory()

    const {
        logout
    } = useAuth0()

    const { profile } = useAppSelector(state => state.session)
    const currentHotelObject = useSelector<any>(state => state.hotels.currentHotelObject) as any

    return (
        <StackedLayout
            navbar={
                <Navbar>
                    <Dropdown>
                        <DropdownButton as={NavbarItem} className="max-lg:hidden">
                            <Avatar src="/logo_rate_small.svg" />
                            <NavbarLabel>BeSafe Rate</NavbarLabel>
                            <ChevronDownIcon />
                        </DropdownButton>
                        <TeamDropdownMenu />
                    </Dropdown>
                    <NavbarDivider className="max-lg:hidden" />
                    <NavbarSection className="max-lg:hidden">
                        <DialogHotelSelector />
                    </NavbarSection>
                    <NavbarDivider className="max-lg:hidden" />
                    <NavbarSection className="max-lg:hidden">
                        <NavbarItem current={history.location.pathname === '/app/suite'} onClick={() => history.push('/app/suite')}>
                            Suite
                        </NavbarItem>
                        <NavbarItem current={history.location.pathname === '/app/dashboard'} onClick={() => history.push('/app/dashboard')}>
                            Dashboard
                        </NavbarItem>
                        {
                            (profile && !profile.partnerId) &&
                            <NavbarItem current={history.location.pathname === '/app/reservations'} onClick={() => history.push('/app/reservations')}>
                                {t('sidebar.reservations')}
                            </NavbarItem>
                        }
                        {
                            false &&
                            <NavbarItem current={history.location.pathname === '/app/quotes'} onClick={() => history.push('/app/quotes')}>
                                {t('sidebar.quotes')}
                            </NavbarItem>
                        }
                        {
                            false &&
                            <NavbarItem current={history.location.pathname === '/app/bedirect'} onClick={() => history.push('/app/bedirect')}>
                                <div>
                                    <span className={'bg-red-600 text-white text-xs rounded-full px-2 py-1'}>Hey!</span> BeDirect
                                </div>
                            </NavbarItem>
                        }
                        {
                            (currentHotelObject && currentHotelObject.idAccomodation === 71) &&
                            <NavbarItem current={history.location.pathname === '/app/premium'} onClick={() => history.push('/app/premium')}>
                                <div className="flex space-x-1">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-5">
                                        <path fillRule="evenodd" d="M8.603 3.799A4.49 4.49 0 0 1 12 2.25c1.357 0 2.573.6 3.397 1.549a4.49 4.49 0 0 1 3.498 1.307 4.491 4.491 0 0 1 1.307 3.497A4.49 4.49 0 0 1 21.75 12a4.49 4.49 0 0 1-1.549 3.397 4.491 4.491 0 0 1-1.307 3.497 4.491 4.491 0 0 1-3.497 1.307A4.49 4.49 0 0 1 12 21.75a4.49 4.49 0 0 1-3.397-1.549 4.49 4.49 0 0 1-3.498-1.306 4.491 4.491 0 0 1-1.307-3.498A4.49 4.49 0 0 1 2.25 12c0-1.357.6-2.573 1.549-3.397a4.49 4.49 0 0 1 1.307-3.497 4.49 4.49 0 0 1 3.497-1.307Zm7.007 6.387a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z" clipRule="evenodd" />
                                    </svg>
                                    <div>{t('sidebar.premium')}</div>
                                </div>
                            </NavbarItem>
                        }
                        {
                            (profile && !profile.partnerId) &&
                            <>
                                <NavbarItem current={history.location.pathname === '/app/invoices'} onClick={() => history.push('/app/invoices')}>
                                    {t('sidebar.invoices')}
                                </NavbarItem>
                                <NavbarItem current={history.location.pathname === '/app/settings'} onClick={() => history.push('/app/settings')}>
                                    {t('general.settings')}
                                </NavbarItem>
                            </>
                        }
                    </NavbarSection>
                    <NavbarSpacer />
                    <NavbarSection>
                        <>
                            <GlobalSearch />
                        </>
                        <NavbarDivider className="max-lg:hidden" />
                        <>
                            <LanguageSelector mini={true}/>
                        </>
                        <NavbarDivider className="max-lg:hidden" />
                        <Dropdown>
                            <DropdownButton as={NavbarItem}>
                                <Avatar slot="icon" initials={profile?.userEmail?.charAt(0).toUpperCase()} className="bg-orange-500 text-white" />
                            </DropdownButton>
                            <DropdownMenu className="min-w-64" anchor="bottom end">
                                {
                                    false &&
                                    <>
                                        <DropdownItem onClick={() => {}}>
                                            <UserIcon />
                                            <DropdownLabel>My profile</DropdownLabel>
                                        </DropdownItem>
                                        <DropdownItem onClick={() => {}}>
                                            <Cog8ToothIcon />
                                            <DropdownLabel>Settings</DropdownLabel>
                                        </DropdownItem>
                                        <DropdownDivider />
                                        <DropdownItem onClick={() => {}}>
                                            <ShieldCheckIcon />
                                            <DropdownLabel>Privacy policy</DropdownLabel>
                                        </DropdownItem>
                                        <DropdownItem onClick={() => {}}>
                                            <LightBulbIcon />
                                            <DropdownLabel>Share feedback</DropdownLabel>
                                        </DropdownItem>
                                        <DropdownDivider />
                                    </>
                                }
                                <DropdownItem onClick={() => logout()}>
                                    <ArrowRightStartOnRectangleIcon />
                                    <DropdownLabel>{t('general.logout')}</DropdownLabel>
                                </DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                    </NavbarSection>
                </Navbar>
            }
            sidebar={
                <Sidebar>
                    <SidebarHeader>
                        <Dropdown>
                            <DropdownButton as={SidebarItem} className="lg:mb-2.5">
                                <Avatar src="/logo_rate_small.svg" />
                                <SidebarLabel>BeSafe Rate</SidebarLabel>
                                <ChevronDownIcon />
                            </DropdownButton>
                            <TeamDropdownMenu />
                        </Dropdown>
                    </SidebarHeader>
                    <SidebarBody>
                        <SidebarSection>
                            <DialogHotelSelector />
                            <SidebarItem current={history.location.pathname === '/app/suite'} onClick={() => history.push('/app/suite')}>
                                Suite
                            </SidebarItem>
                            <SidebarItem current={history.location.pathname === '/app/dashboard'} onClick={() => history.push('/app/dashboard')}>
                                Dashboard
                            </SidebarItem>
                            {
                                false &&
                                <SidebarItem current={history.location.pathname === '/app/quotes'} onClick={() => history.push('/app/quotes')}>
                                    {t('sidebar.quotes')}
                                </SidebarItem>
                            }
                            <SidebarItem current={history.location.pathname === '/app/bedirect'} onClick={() => history.push('/app/bedirect')}>
                                BeDirect
                            </SidebarItem>
                            <SidebarItem current={history.location.pathname === '/app/reservations'} onClick={() => history.push('/app/reservations')}>
                                {t('sidebar.reservations')}
                            </SidebarItem>
                            {
                                (currentHotelObject && currentHotelObject.idAccommodation === 71) &&
                                <SidebarItem current={history.location.pathname === '/app/premium'} onClick={() => history.push('/app/premium')}>
                                    {t('sidebar.premium')}
                                </SidebarItem>
                            }
                            <SidebarItem current={history.location.pathname === '/app/invoices'} onClick={() => history.push('/app/invoices')}>
                                {t('sidebar.invoices')}
                            </SidebarItem>
                            <SidebarItem current={history.location.pathname === '/app/settings'} onClick={() => history.push('/app/settings')}>
                                {t('general.settings')}
                            </SidebarItem>
                        </SidebarSection>
                    </SidebarBody>
                </Sidebar>
            }
        >
            <div className="h-full overflow-auto">
                {children}
            </div>
        </StackedLayout>
    )
}
